import React from 'react';
import './styles.css';

// Nothing in the app touches Purview/Information Protection yet — this
// ships as an honest "not available" state rather than mock sensitivity
// labels, DLP or retention data.
export default function DataProtection() {
  return (
    <div className="detail-hero">
      <span className="pill detail-hero__pill pill--bad">Ikke tilgængeligt endnu</span>
      <h2>Databeskyttelse</h2>
      <p>Sensitivity labels, DLP-politikker og opbevaringsregler. Denne del af NordComply er endnu ikke bygget. NordComply henter i dag ikke data fra Microsoft Purview.</p>
    </div>
  );
}
